import type { IntlShape } from '@atlassian/jira-intl';
import {
	ESTIMATION_STORY_POINTS,
	ESTIMATION_ORIGINAL_ESTIMATE,
} from '@atlassian/jira-software-report-charting-common/src/common/utils/format-estimate/index.tsx';
import commonMessages from '../../../common/messages';
import type { SprintReportsEstimationStatistic } from '../../../common/types';

/**
 * Render an axis' statistic field to a string
 */
const renderStatisticField = (
	statisticField: SprintReportsEstimationStatistic,
	intl: IntlShape,
) => {
	switch (statisticField) {
		case ESTIMATION_STORY_POINTS:
			return intl.formatMessage(commonMessages.optionStatisticStoryPoints);

		case ESTIMATION_ORIGINAL_ESTIMATE:
			return intl.formatMessage(commonMessages.optionStatisticOriginalEstimate);

		default:
			return intl.formatMessage(commonMessages.optionStatisticIssueCount);
	}
};

export default renderStatisticField;
